export const BUILD_INFO = {
  buildId: '181552',
  commit: '7f63f2c'
};
